import { Badge, Button, Menu, MenuItem } from "@mui/material";
import { observer } from "mobx-react-lite";
import React, { useRef, useState } from "react";
import useTranslation from "../../../hooks/useTranslation";
import authStore from "../../../stores/AuthStore";
import { UserRoles } from "../../../stores/AuthStore/types";
import { useNavigate } from "react-router-dom";
import notificationStore from "../../../stores/NotificationStore";
import offerStore from "../../../stores/OfferStore";
import caseStore from "../../../stores/CaseStore";
import configStore from "../../../stores/ConfigStore";
import ChangePassword from "../ChangePassword";

const UserMenu = observer(() => {
  const { t } = useTranslation();
  const menuRef = useRef(null);
  const menuButtonRef = useRef(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [changePasswordOpen, setChangePasswordOpen] = React.useState(false);

  const handleProfileDropdownClick = () => {
    setOpen(!open);
  };

  const handleLogoutClick = () => {
    authStore.logout().then(() => window.location.replace("/login"));
  };

  return (
    <div>
      <Button
        ref={menuButtonRef}
        id="user-menu-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        size={"large"}
        color={"inherit"}
        onClick={handleProfileDropdownClick}
      >
        {authStore.userHasRole(UserRoles.ADMIN) ? (
          <Badge
            badgeContent={
              notificationStore.notifications.filter((n) => !n.isRead).length
            }
            color={"error"}
          >
            <i className="fa fa-user-tie" style={{ fontSize: "20px" }} />
          </Badge>
        ) : (
          <Badge
            badgeContent={
              notificationStore.notifications.filter((n) => !n.isRead).length
            }
            color={"error"}
          >
            <i className="fa fa-user" style={{ fontSize: "20px" }} />
          </Badge>
        )}
        <span className="ml hidden-sm">
          {authStore.userHasRole(UserRoles.LAWYER) && "Av. "}
          {authStore.user.firstName} {authStore.user.lastName}
        </span>
      </Button>
      <Menu
        id="user-menu"
        anchorEl={menuButtonRef.current}
        open={open}
        onClose={() => setOpen(false)}
        onClick={() => setOpen(false)}
        ref={menuRef}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={() => navigate("/profile")}>{t("profile")}</MenuItem>
        <MenuItem onClick={() => setChangePasswordOpen(true)}>
          {t("changePassword")}
        </MenuItem>
        <MenuItem onClick={() => navigate("/notifications")}>
          {t("notifications")} (
          {notificationStore.notifications.filter((n) => !n.isRead).length})
        </MenuItem>
        {authStore.userHasRole(UserRoles.USER) && (
          <MenuItem onClick={() => navigate("/cases")}>
            {t("your-cases")} ({caseStore.userCases.length} /{" "}
            {configStore.appConfig.caseLimit})
          </MenuItem>
        )}
        {(authStore.userHasRole(UserRoles.USER) ||
          authStore.userHasRole(UserRoles.LAWYER)) && (
          <MenuItem onClick={() => navigate("/incoming-offers")}>
            {t("incoming-offers")} ({offerStore.userOffers.length})
          </MenuItem>
        )}
        {authStore.userHasRole(UserRoles.LAWYER) && (
          <MenuItem onClick={() => navigate("/offers")}>
            {t("your-offers")} ({offerStore.lawyerOffers.length})
          </MenuItem>
        )}
        {authStore.userHasRole(UserRoles.ADMIN) && (
          <MenuItem onClick={() => navigate("/dictionary-management")}>
            Çeviriler
          </MenuItem>
        )}
        {authStore.userHasRole(UserRoles.ADMIN) && (
          <MenuItem onClick={() => navigate("/categories-management")}>
            Kategoriler
          </MenuItem>
        )}
        {authStore.userHasRole(UserRoles.ADMIN) && (
          <MenuItem
            onClick={() =>
              navigate("/static-content-management/user-agreement")
            }
          >
            Kullanıcı Sözleşmesi
          </MenuItem>
        )}
        <MenuItem onClick={handleLogoutClick}>{t("logout")}</MenuItem>
      </Menu>
      <ChangePassword
        dialogOpen={changePasswordOpen}
        setDialogOpen={setChangePasswordOpen}
      />
    </div>
  );
});

export default UserMenu;
